import request from '@/utils/request'
import { UserModule } from '@/store/modules/user'

function storeIdFromContext(explicit?: number | string): number | undefined {
  if (explicit != null && explicit !== '') {
    const n = Number(explicit)
    if (!Number.isNaN(n)) return n
  }
  const sid = UserModule.storeId
  return sid ? Number(sid) : undefined
}
// 营业额数据
// export const getTurnoverDataes = (data) =>
//   request({
//     'url': `/report/turnoverStatistics`,
//     'method': 'get',
//     data
//   })
// 首页数据
// // 今日数据
// export const getTodayDataes = () =>
//   request({
//     'url': `/workspace/todaydate`,
//     'method': 'get'
//   })
export const getOrderData = (storeId?: number | string) => {
  const sid = storeIdFromContext(storeId)
  const params = sid != null ? { storeId: sid } : {}
  return request({ url: '/workspace/overviewOrders', method: 'get', params })
}

export const getOverviewDishes = (storeId?: number | string) => {
  const sid = storeIdFromContext(storeId)
  const params = sid != null ? { storeId: sid } : {}
  return request({ url: '/workspace/overviewDishes', method: 'get', params })
}

export const getSetMealStatistics = (storeId?: number | string) => {
  const sid = storeIdFromContext(storeId)
  const params = sid != null ? { storeId: sid } : {}
  return request({ url: '/workspace/overviewSetmeals', method: 'get', params })
}

export const getBusinessData = (storeId?: number | string) => {
  const sid = storeIdFromContext(storeId)
  const params = sid != null ? { storeId: sid } : {}
  return request({ url: '/workspace/businessData', method: 'get', params })
}
/**
 *
 * 报表数据
 *
 **/
// 统计
// 获取当日销售数据 -> 顶部数据
// export const getDataes = (params: any) =>
//   request({
//     'url': `/report/amountCollect/${params.date}`,
//     'method': 'get'
//   })

// 营业额统计（storeId 可选，有则按顶栏所选商户）
export const getTurnoverStatistics = (params: { begin: any; end: any; storeId?: number | string }) => {
  const { begin, end, storeId } = params
  const sid = storeIdFromContext(storeId)
  const query: Record<string, any> = { begin, end }
  if (sid != null) query.storeId = sid
  return request({ url: '/report/turnoverStatistics', method: 'get', params: query })
}

// 用户统计（仅全平台）
export const getUserStatistics = (params: any) =>
  request({
    url: '/report/userStatistics',
    method: 'get',
    params,
  })

// 订单统计
export const getOrderStatistics = (params: { begin: any; end: any; storeId?: number | string }) => {
  const { begin, end, storeId } = params
  const sid = storeIdFromContext(storeId)
  const query: Record<string, any> = { begin, end }
  if (sid != null) query.storeId = sid
  return request({ url: '/report/ordersStatistics', method: 'get', params: query })
}

// 销量排名 TOP10
export const getTop = (params: { begin: any; end: any; storeId?: number | string }) => {
  const { begin, end, storeId } = params
  const sid = storeIdFromContext(storeId)
  const query: Record<string, any> = { begin, end }
  if (sid != null) query.storeId = sid
  return request({ url: '/report/top10', method: 'get', params: query })
}
  // 数据概览
  export const getDataOverView= (params: any) =>
  request({
    'url': `/report/dataOverView`,
    'method': 'get',
    params
  })
  // 导出营业数据（传 storeId 仅导出该店；不传则后端按店分 Sheet）
  export function exportInfor(storeId?: number | string) {
    const params: Record<string, any> = {}
    if (storeId != null && storeId !== '') {
      const n = Number(storeId)
      if (!Number.isNaN(n)) params.storeId = n
    }
    return request({
      url: '/report/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  }

  // 导出近一个月订单（含营业额/完成数/取消数）
  export function exportOrderInfor(storeId?: number | string) {
    const params: Record<string, any> = {}
    if (storeId != null && storeId !== '') {
      const n = Number(storeId)
      if (!Number.isNaN(n)) params.storeId = n
    }
    return request({
      url: '/report/exportOrders',
      method: 'get',
      params,
      responseType: 'blob'
    })
  }
